/* ============================================================
   Mybibblio — personalisation form helpers (product page)
   The form is always open and sits right under the title + price,
   so a shopper never has to "unlock" it. This script only:
   • jumps to the form (#personalise) from the top "Start personalising"
     link, and on arrival from a shop/homepage card's button
     (/products/x#personalise) — one click from the shop to the form;
   • on phones, pins a compact copy of the photo strip to the top
     (html.mb-pinned) once the shopper starts using the form, so
     art-style changes stay visible. The page is scroll-compensated
     so nothing jumps under their finger.
   Pure presentation — the form itself is untouched.
   ============================================================ */
(function () {
  var MOBILE = '(max-width: 749px)';
  function isMobile() { try { return window.matchMedia(MOBILE).matches; } catch (e) { return false; } }

  // the form controls a first interaction with should pin the photo strip
  var FORM_SEL = '#personalise, variant-picker, [data-kb-kids], .kb-format, .kb-ded, .kb-consent, .kb-trio, [data-mb-trilogy]';

  function init() {
    var anchor = document.getElementById('personalise');
    if (!anchor || anchor.dataset.mbInit === '1') return;
    anchor.dataset.mbInit = '1';

    // legacy safety: if an older template with the gate is ever served, open it
    var gate = document.querySelector('[data-mb-gate]');
    if (gate && gate.parentElement && gate.parentElement.parentElement) {
      gate.parentElement.parentElement.classList.add('mb-form-open');
      gate.hidden = true;
    }

    var root = document.documentElement;
    function media() { return document.querySelector('main[data-template="product"] .product-information__media'); }

    // Pin the photo strip; keep `keep` (the control just used) where it was on screen,
    // then make sure it isn't hidden under the pinned strip.
    function pin(keep) {
      if (!isMobile() || root.classList.contains('mb-pinned')) return;
      var before = keep ? keep.getBoundingClientRect().top : null;
      root.classList.add('mb-pinned');
      if (!keep) return;
      try {
        var dy = keep.getBoundingClientRect().top - before;
        if (dy) window.scrollBy(0, dy);
        var m = media();
        var clear = m ? m.getBoundingClientRect().bottom + 12 : 0;
        var top = keep.getBoundingClientRect().top;
        if (top < clear) window.scrollBy(0, top - clear);
      } catch (e) {}
    }

    // space taken at the top of the screen: the pinned photo strip on phones
    // (it sits under the sticky header), otherwise the header itself
    function topClearance() {
      var m = media();
      if (m && isMobile() && root.classList.contains('mb-pinned')) {
        return (parseFloat(getComputedStyle(m).top) || 0) + m.offsetHeight + 12;
      }
      return (parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height')) || 0) + 14;
    }
    function goToForm(smooth) {
      pin(null);
      var y = anchor.getBoundingClientRect().top + (window.pageYOffset || 0) - topClearance();
      try { window.scrollTo({ top: Math.max(0, y), behavior: smooth ? 'smooth' : 'auto' }); }
      catch (e) { window.scrollTo(0, Math.max(0, y)); }
    }

    // "Start personalising" at the top of the page (a plain #personalise link without JS)
    document.addEventListener('click', function (e) {
      var q = e.target.closest && e.target.closest('[data-mb-open-form]');
      if (!q) return;
      e.preventDefault();
      goToForm(true);
    });

    // first real use of the form pins the photo strip (after the click has landed)
    function onUse(e) {
      if (root.classList.contains('mb-pinned') || !isMobile()) return;
      var t = e.target;
      var ctl = t && t.closest && t.closest(FORM_SEL);
      if (!ctl) return;
      var keep = (t.closest && t.closest('label, button, input, textarea, .kb-format__opt, .kb-kidcount__opt')) || ctl;
      setTimeout(function () { pin(keep); }, 0);
    }
    document.addEventListener('click', onUse, true);
    document.addEventListener('input', onUse, true);

    // arriving from a shop/homepage card's "Start personalising" button
    if (location.hash === '#personalise') {
      var userMoved = false;
      ['wheel', 'touchstart', 'keydown'].forEach(function (ev) {
        window.addEventListener(ev, function () { userMoved = true; }, { passive: true, once: true });
      });
      requestAnimationFrame(function () { goToForm(false); });
      // images above can still settle after first paint — re-align unless they've scrolled
      window.addEventListener('load', function () { if (!userMoved) goToForm(false); }, { once: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
